import { NgModule } from "@angular/core";
import { DxTagBoxModule } from "devextreme-angular";
import { TagBoxComponent } from "./tag-box.component";

@NgModule({
  imports: [DxTagBoxModule],
  declarations: [TagBoxComponent],
  exports: [TagBoxComponent]
})
export class TagBoxModule {}
